import React from "react";

const DropDownSVG = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="13.734"
      height="8.334"
      viewBox="0 0 13.734 8.334"
    >
      <path
        fill="none"
        stroke="#292929"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1.413 1.413l5.454 5.921 5.454-5.921"
        data-name="Dropdown Icon"
      ></path>
    </svg>
  );
};

export default DropDownSVG;
